import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import TextField from './text-field';

interface Props {
  value: string,
  part: string,
  placeholder: string,
  disabled?: boolean,
  onChange?: (part: string, newVal: string) => void,
}

const AddressPartLabel = styled(InputLabel)`
  padding: 5px;
`;

const AddressPart: React.FC<Props> = ({
  value,
  part,
  placeholder,
  disabled = false,
  onChange,
}: Props) => {
  const [inputValue, setInputValue] = useState(value || '');
  const handleChange = (changedValue: Record<string, any>) => {
    const newValue = changedValue.textValue;
    setInputValue(newValue);
    if (onChange) {
      onChange(part, newValue);
    }
  };

  return (
    <AddressPartLabel>
      { /* @ts-ignore */ }
      <TextField
        required={false}
        disabled={disabled}
        value={{ textValue: inputValue }}
        onChange={handleChange}
        label={placeholder}
      />
    </AddressPartLabel>
  );
};

export default AddressPart;
